import { ProductCache } from './dataLayer';

window.dataLayer = window.dataLayer || [];
// uncomment for debugging
// if (!('_push' in window.dataLayer)) {
//     window.dataLayer._push = window.dataLayer.push;
//     window.dataLayer.push = function push () {
//         var args = Array.from(arguments);
//         console.warn(JSON.stringify(args[0], null, 2));
//         window.dataLayer._push.apply(window.dataLayer, args);
//     }
// }


/*********************************** EXPORTS ***********************************/

window.ORW.caches = window.ORW.caches || {};
window.ORW.caches.products = window.ORW.caches.products || new ProductCache();

// helpers
import * as _ from './util';
export { _ };

// tracking
export { default as addToBag } from './trackAddToBag';
export { default as quickShopClick } from './trackQuickShopClick';
export { default as homepageClick } from './trackHomepageClick';
export { default as productClick } from './trackProductClick';
export { default as productDetailPage } from './trackProductDetailPage';

import initProductImpression from './trackProductImpression';
export const productImpression = initProductImpression();